import React from "react";
import RecentlyActiveDataBuilder from "../data/RecentlyActiveDataBuilder";
import { RecentlyActiveUsersEditorContainer } from "./styled";

function RecentlyActiveEditor() {
  return (
    <RecentlyActiveUsersEditorContainer>
      <RecentlyActiveDataBuilder />
    </RecentlyActiveUsersEditorContainer>
  );
}

export default RecentlyActiveEditor;
